import React from 'react'
import { graphql } from 'gatsby'
import EmbeddedContentGrid, {
  EmbeddedContentGridContent,
} from 'src/components/organisms/general/embeddedContentGrid'
import { PrismicPageDataBodyEmbeddedContentGrid } from 'src/typings/generated/graphql'

type Props = {
  slice: PrismicPageDataBodyEmbeddedContentGrid
}

const EmbeddedContentGridSlice = ({ slice }: Props) => {
  const content: EmbeddedContentGridContent = {
    items: slice.items ?? undefined,
  }

  return <EmbeddedContentGrid media={content} />
}

export default EmbeddedContentGridSlice

export const EmbeddedContentGridFragment = graphql`
  fragment PageDataBodyEmbeddedContentGrid on PrismicPageDataBodyEmbeddedContentGrid {
    items {
      link_to_embed {
        url
      }
      video_title
    }
  }
`
